import { render } from "./TheHeading.vue?vue&type=template&id=20d415e4"
import script from "./TheHeading.vue?vue&type=script&lang=js"
export * from "./TheHeading.vue?vue&type=script&lang=js"
script.render = render

export default script